import { IRadprisJustering } from "../../models/IProduktdefinition";

export class RadprisJustering {
    startlangd: number;
    justering?: number;
    dirty = false;
    constructor(model: IRadprisJustering, dirty = false) {
        this.justering = model.justering;
        this.startlangd = model.startlangd;
        this.dirty = dirty;
    }

    mapToDto(): IRadprisJustering {
        return {
            startlangd: this.startlangd,
            justering: this.justering
        };
    }
}
